import { createFileRoute } from '@tanstack/react-router';
import { StatutoryStandardRegistryPage } from './-components/StatutoryStandardRegistryPage';
export const Route = createFileRoute('/_staff/legal-welfare-and-taxes-mock/_layout/statutory-standards/')({
  component: StatutoryStandardRegistryPage
});